import React, { useState } from 'react'
import { Input, Icon } from 'tea-component'

import { useLocal } from '@/pages/dashboard/utils/customHook'

const CustomizedPanel = (props) => {
  const {
    value: valueProps,
    isError,
    cacheValue,
    maximumDays,
    onInputChange,
    onErrorChange
  } = props
  const { getLocalText } = useLocal('component_tracking_day')
  const value = cacheValue?.replace('1-', '')
  // const errorMessage = `You entered improper number.<br /> Please re-enter the tracking day in [1,${maximumDays}].`
  const errorMessage = getLocalText('error', {maximumDays})

  const handleError = (value) => {
    if (isNaN(value) || value > maximumDays || value === '' || value === '0' || value < 1) {
      return true
    }
    return false
  }

  const handleChange = (newValue) => {
    // 不允许输入负数
    newValue = newValue < 0 ? '0' : newValue
    const isError = handleError(newValue)
    onErrorChange?.(isError)

    newValue = isError ? newValue : Number(newValue) + ''

    onInputChange?.(newValue)
  }

  const handleClear = () => {
    handleChange('')
  }

  return (
    <>
      <div className='dtb-db-tracking-day__input-box'>
        <Input
          value={value}
          placeholder={getLocalText('placeholder')}
          onChange={handleChange}
        />
        {valueProps?.length > 0 && <Icon type='dismiss' onClick={handleClear}/>}
      </div>
      {
        isError && value !== '' ? (
          <div className='dtb-db-tracking-day--error'>
            <span className='dtb-db-tracking-day--error-text' dangerouslySetInnerHTML={{__html: errorMessage}}/>
          </div>
        ) : ''
      }
    </>
  )
}

export default CustomizedPanel